/*** IMPORTS FROM imports-loader ***/
var global = window;

module.exports = function lines(str) {
  if (str == null) return [];
  return String(str).split(/\r\n?|\n/);
};

